// extracted by mini-css-extract-plugin
export default {"root":"PlasmicEmail1_root__X4XHz","rootdanger":"PlasmicEmail1_rootdanger__6fKE8"};